import { useState } from "react";
import { Trash2 } from "lucide-react";

import { Button } from "@/components/ui/button";
import ConfirmDialog from "@/components/ui/ConfirmDialog";
import { useAppDispatch } from "@/stores/hook";

import { setIsAddCourse } from "../../../stores/courseFunctionalSlice";
import { useCourseForm } from "../../../contexts/FormCourseContext";
import { useCourseMutations } from "../../../api/useCourseMutations";

export default function Actions() {
  const dispatch = useAppDispatch();
  const {
    handleSubmit,
    reset,
    onSubmit,
    isSubmitting,
    isEditMode,
    courseId,
    closeDrawer,
  } = useCourseForm();

  const [confirmOpen, setConfirmOpen] = useState(false);

  const { deleteCourse } = useCourseMutations();

  const handleConfirmDelete = async () => {
    if (!courseId) return;
    try {
      await deleteCourse.mutateAsync(Number(courseId));
      setConfirmOpen(false);
      closeDrawer?.();
    } catch {
      /* handled by mutation onError */
    }
  };

  return (
    <div className="w-full h-full flex justify-between items-center">
      <div>
        {isEditMode && (
          <Button
            type="button"
            variant="ghost"
            onClick={() => setConfirmOpen(true)}
            disabled={isSubmitting || deleteCourse.isPending}
            className="!text-[var(--color-error,#da2a46)] hover:!bg-red-50 gap-1.5"
          >
            <Trash2 size={16} />
            Delete
          </Button>
        )}
      </div>

      <div className="flex gap-10">
        <Button
          type="button"
          onClick={() => {
            reset();
            dispatch(setIsAddCourse(false));
          }}
          variant="cancel"
          disabled={isSubmitting}
          className={isSubmitting ? "opacity-70 cursor-not-allowed" : ""}
        >
          Cancel
        </Button>

        <Button
          type="button"
          variant="primary"
          onClick={handleSubmit(onSubmit)}
          disabled={isSubmitting}
          className={isSubmitting ? "opacity-70 cursor-not-allowed" : ""}
        >
          {isSubmitting
            ? isEditMode
              ? "Updating..."
              : "Saving..."
            : isEditMode
              ? "Update Course"
              : "Save Course"}
        </Button>
      </div>

      <ConfirmDialog
        open={confirmOpen}
        onClose={() => {
          if (!deleteCourse.isPending) setConfirmOpen(false);
        }}
        onConfirm={handleConfirmDelete}
        title="Delete this course?"
        tone="destructive"
        warningTitle="This action cannot be undone"
        warningDescription={
          <span>
            The course, its admission criteria, attached brochures/documents,
            custom field values, and any lead/child mappings to it will be
            permanently removed.
          </span>
        }
        confirmLabel="Delete Course"
        loadingLabel="Deleting…"
        isLoading={deleteCourse.isPending}
      />
    </div>
  );
}
